export const AVATAR_ASSETS = {
  T_SHIRT_ID: '191376570',
}
export const femAdultAvatars = [
  {
    imageUrl: 'https://readyplayerme-avatars.s3.amazonaws.com/avatar-template-images/white-female-1.png',
    gender: 'female',
    usageType: 'randomize',
    id: '645cd1cef23d0562d3f9d28d',
  },
  {
    imageUrl: 'https://readyplayerme-avatars.s3.amazonaws.com/avatar-template-images/black-female-1.png',
    gender: 'female',
    usageType: 'randomize',
    id: '645cd13ff23d0562d3f9d281',
  },
  {
    imageUrl: 'https://readyplayerme-avatars.s3.amazonaws.com/avatar-template-images/asian-female-1.png',
    gender: 'female',
    usageType: 'randomize',
    id: '645ccc4df23d0562d3f9d274',
  },
  {
    imageUrl: 'https://readyplayerme-avatars.s3.amazonaws.com/avatar-template-images/indian-female-1.png',
    gender: 'female',
    usageType: 'randomize',
    id: '645cd18ef23d0562d3f9d287',
  },
  {
    imageUrl: 'https://readyplayerme-avatars.s3.amazonaws.com/avatar-template-images/white-female-2.png',
    gender: 'female',
    usageType: 'randomize',
    id: '645cd1d5f23d0562d3f9d28e',
  },
  {
    imageUrl: 'https://readyplayerme-avatars.s3.amazonaws.com/avatar-template-images/black-female-2.png',
    gender: 'female',
    usageType: 'randomize',
    id: '645cd14ff23d0562d3f9d282',
  },
  {
    imageUrl: 'https://readyplayerme-avatars.s3.amazonaws.com/avatar-template-images/asian-female-2.png',
    gender: 'female',
    usageType: 'randomize',
    id: '645cd00bf23d0562d3f9d27c',
  },
  {
    imageUrl: 'https://readyplayerme-avatars.s3.amazonaws.com/avatar-template-images/indian-female-2.png',
    gender: 'female',
    usageType: 'randomize',
    id: '645cd19af23d0562d3f9d288',
  },
  {
    imageUrl: 'https://readyplayerme-avatars.s3.amazonaws.com/avatar-template-images/white-female-3.png',
    gender: 'female',
    usageType: 'randomize',
    id: '645cd1e9f23d0562d3f9d28f',
  },
  {
    imageUrl: 'https://readyplayerme-avatars.s3.amazonaws.com/avatar-template-images/black-female-3.png',
    gender: 'female',
    usageType: 'randomize',
    id: '645cd15df23d0562d3f9d283',
  },
  {
    imageUrl: 'https://readyplayerme-avatars.s3.amazonaws.com/avatar-template-images/asian-female-3.png',
    gender: 'female',
    usageType: 'randomize',
    id: '645cd118f23d0562d3f9d27d',
  },
  {
    imageUrl: 'https://readyplayerme-avatars.s3.amazonaws.com/avatar-template-images/indian-female-3.png',
    gender: 'female',
    usageType: 'randomize',
    id: '645cd1a3f23d0562d3f9d289',
  },
]

export const mascAdultAvatars = [
  {
    imageUrl: 'https://readyplayerme-avatars.s3.amazonaws.com/avatar-template-images/white-male-1.png',
    gender: 'male',
    usageType: 'randomize',
    id: '645cd1eff23d0562d3f9d290',
  },
  {
    imageUrl: 'https://readyplayerme-avatars.s3.amazonaws.com/avatar-template-images/black-male-1.png',
    gender: 'male',
    usageType: 'randomize',
    id: '645cd172f23d0562d3f9d284',
  },
  {
    imageUrl: 'https://readyplayerme-avatars.s3.amazonaws.com/avatar-template-images/asian-male-1.png',
    gender: 'male',
    usageType: 'randomize',
    id: '645cd123f23d0562d3f9d27e',
  },
  {
    imageUrl: 'https://readyplayerme-avatars.s3.amazonaws.com/avatar-template-images/indian-male-1.png',
    gender: 'male',
    usageType: 'randomize',
    id: '645cd1b2f23d0562d3f9d28a',
  },
  {
    imageUrl: 'https://readyplayerme-avatars.s3.amazonaws.com/avatar-template-images/white-male-2.png',
    gender: 'male',
    usageType: 'randomize',
    id: '645cd1f6f23d0562d3f9d291',
  },
  {
    imageUrl: 'https://readyplayerme-avatars.s3.amazonaws.com/avatar-template-images/black-male-2.png',
    gender: 'male',
    usageType: 'randomize',
    id: '645cd180f23d0562d3f9d285',
  },
  {
    imageUrl: 'https://readyplayerme-avatars.s3.amazonaws.com/avatar-template-images/asian-male-2.png',
    gender: 'male',
    usageType: 'randomize',
    id: '645cd12cf23d0562d3f9d27f',
  },
  {
    imageUrl: 'https://readyplayerme-avatars.s3.amazonaws.com/avatar-template-images/indian-male-2.png',
    gender: 'male',
    usageType: 'randomize',
    id: '645cd1bdf23d0562d3f9d28b',
  },
  {
    imageUrl: 'https://readyplayerme-avatars.s3.amazonaws.com/avatar-template-images/white-male-3.png',
    gender: 'male',
    usageType: 'randomize',
    id: '645cd1fdf23d0562d3f9d292',
  },
  {
    imageUrl: 'https://readyplayerme-avatars.s3.amazonaws.com/avatar-template-images/black-male-3.png',
    gender: 'male',
    usageType: 'randomize',
    id: '645cd186f23d0562d3f9d286',
  },
  {
    imageUrl: 'https://readyplayerme-avatars.s3.amazonaws.com/avatar-template-images/asian-male-3.png',
    gender: 'male',
    usageType: 'randomize',
    id: '645cd134f23d0562d3f9d280',
  },
  {
    imageUrl: 'https://readyplayerme-avatars.s3.amazonaws.com/avatar-template-images/indian-male-3.png',
    gender: 'male',
    usageType: 'randomize',
    id: '645cd1c5f23d0562d3f9d28c',
  },
]

export const femAvatars = [
  {
    glb: 'https://d36kdoifvevep6.cloudfront.net/avatars/custom/under-13/glb/A_Girl-01_v01.glb',
    png: 'avatars/custom/under-13/png/Porfile_AG01_v01.png',
    transparentPng: 'avatars/custom/under-13/png/Profile-transparent_A_Girl_01_v01.png',
    id: '5408ad5c77480b6857343ade',
  },
  {
    glb: 'https://d36kdoifvevep6.cloudfront.net/avatars/custom/under-13/glb/A_Girl-02_v01.glb',
    png: 'avatars/custom/under-13/png/Porfile_AG02_v01.png',
    transparentPng: 'avatars/custom/under-13/png/Profile-transparent_A_Girl_02_v01.png',
    id: '6633482524567b3331cfcb67',
  },
  {
    glb: 'https://d36kdoifvevep6.cloudfront.net/avatars/custom/under-13/glb/A_Girl-03_v01.glb',
    png: 'avatars/custom/under-13/png/Porfile_AG03_v01.png',
    transparentPng: 'avatars/custom/under-13/png/Profile-transparent_A_Girl_03_v01.png',
    id: '6cb40712e82f12d8f9d3cc99',
  },
  {
    glb: 'https://d36kdoifvevep6.cloudfront.net/avatars/custom/under-13/glb/A_Girl-04_v01.glb',
    png: 'avatars/custom/under-13/png/Porfile_AG04_v01.png',
    transparentPng: 'avatars/custom/under-13/png/Profile-transparent_A_Girl_04_v01.png',
    id: 'da119c8cb431dbd3ac4e2264',
  },
  {
    glb: 'https://d36kdoifvevep6.cloudfront.net/avatars/custom/under-13/glb/B_Girl-01_v01.glb',
    png: 'avatars/custom/under-13/png/Porfile_BG01_v01.png',
    transparentPng: 'avatars/custom/under-13/png/Profile-transparent_B_Girl_01_v01.png',
    id: '97742a662178be1f43ca7b75',
  },
  {
    glb: 'https://d36kdoifvevep6.cloudfront.net/avatars/custom/under-13/glb/B_Girl-02_v01.glb',
    png: 'avatars/custom/under-13/png/Porfile_BG02_v01.png',
    transparentPng: 'avatars/custom/under-13/png/Profile-transparent_B_Girl_02_v01.png',
    id: '80a3caad117f58d0864bb341',
  },
  {
    glb: 'https://d36kdoifvevep6.cloudfront.net/avatars/custom/under-13/glb/B_Girl-03_v01.glb',
    png: 'avatars/custom/under-13/png/Porfile_BG03_v01.png',
    transparentPng: 'avatars/custom/under-13/png/Profile-transparent_B_Girl_03_v01.png',
    id: 'ec855218048c11e3b06360cf',
  },
  {
    glb: 'https://d36kdoifvevep6.cloudfront.net/avatars/custom/under-13/glb/B_Girl-04_v01.glb',
    png: 'avatars/custom/under-13/png/Porfile_BG04_v01.png',
    transparentPng: 'avatars/custom/under-13/png/Profile-transparent_B_Girl_04_v01.png',
    id: 'a5748bdd4c9e7afa7a7e9f14',
  },
  {
    glb: 'https://d36kdoifvevep6.cloudfront.net/avatars/custom/under-13/glb/W_Girl-01_v01.glb',
    png: 'avatars/custom/under-13/png/Porfile_WG01_v01.png',
    transparentPng: 'avatars/custom/under-13/png/Profile-transparent_W_Girl_01_v01.png',
    id: '4db56d6e57d016a6159a13e7',
  },
  {
    glb: 'https://d36kdoifvevep6.cloudfront.net/avatars/custom/under-13/glb/W_Girl-02_v01.glb',
    png: 'avatars/custom/under-13/png/Porfile_WG02_v01.png',
    transparentPng: 'avatars/custom/under-13/png/Profile-transparent_W_Girl_02_v01.png',
    id: '14ef6b5fb9cf49011dc361e6',
  },
  {
    glb: 'https://d36kdoifvevep6.cloudfront.net/avatars/custom/under-13/glb/W_Girl-03_v01.glb',
    png: 'avatars/custom/under-13/png/Porfile_WG03_v01.png',
    transparentPng: 'avatars/custom/under-13/png/Profile-transparent_W_Girl_03_v01.png',
    id: '08a1871f641296b1c11da2fa',
  },
  {
    glb: 'https://d36kdoifvevep6.cloudfront.net/avatars/custom/under-13/glb/W_Girl-04_v01.glb',
    png: 'avatars/custom/under-13/png/Porfile_WG04_v01.png',
    transparentPng: 'avatars/custom/under-13/png/Profile-transparent_W_Girl_04_v01.png',
    id: '7053665ee34bf32066447408',
  },
]

export const mascAvatars = [
  {
    glb: 'https://d36kdoifvevep6.cloudfront.net/avatars/custom/under-13/glb/A_Boy-01_v01.glb',
    png: 'avatars/custom/under-13/png/Porfile_AB01_v01.png',
    transparentPng: 'avatars/custom/under-13/png/Profile-transparent_A_Boy_01_v01.png',
    id: '7172f8faffd51997662c68bb',
  },
  {
    glb: 'https://d36kdoifvevep6.cloudfront.net/avatars/custom/under-13/glb/A_Boy-02_v01.glb',
    png: 'avatars/custom/under-13/png/Porfile_AB02_v01.png',
    transparentPng: 'avatars/custom/under-13/png/Profile-transparent_A_Boy_02_v02.png',
    id: 'd8fc692c12d78ee45948e2e7',
  },
  {
    glb: 'https://d36kdoifvevep6.cloudfront.net/avatars/custom/under-13/glb/A_Boy-03_v01.glb',
    png: 'avatars/custom/under-13/png/Porfile_AB03_v01.png',
    transparentPng: 'avatars/custom/under-13/png/Profile-transparent_A_Boy_03_v01.png',
    id: 'fc3f1c2c504eb7eb08f79b37',
  },
  {
    glb: 'https://d36kdoifvevep6.cloudfront.net/avatars/custom/under-13/glb/A_Boy-04_v01.glb',
    png: 'avatars/custom/under-13/png/Porfile_AB04_v01.png',
    transparentPng: 'avatars/custom/under-13/png/Profile-transparent_A_Boy_04_v01.png',
    id: '1a6deb885e9cb08382c80913',
  },
  {
    glb: 'https://d36kdoifvevep6.cloudfront.net/avatars/custom/under-13/glb/B_Boy-01_v01.glb',
    png: 'avatars/custom/under-13/png/Porfile_BB01_v01.png',
    transparentPng: 'avatars/custom/under-13/png/Profile-transparent_B_Boy_01_v01.png',
    id: '4b229fbcdfbef15f619502e3',
  },
  {
    glb: 'https://d36kdoifvevep6.cloudfront.net/avatars/custom/under-13/glb/B_Boy-02_v01.glb',
    png: 'avatars/custom/under-13/png/Porfile_BB02_v01.png',
    transparentPng: 'avatars/custom/under-13/png/Profile-transparent_B_Boy_02_v01.png',
    id: 'b92cd01d1cbabe6dd11d9e78',
  },
  {
    glb: 'https://d36kdoifvevep6.cloudfront.net/avatars/custom/under-13/glb/B_Boy-03_v01.glb',
    png: 'avatars/custom/under-13/png/Porfile_BB03_v01.png',
    transparentPng: 'avatars/custom/under-13/png/Profile-transparent_B_Boy_03_v01.png',
    id: 'bc3e1a3fdc543960c0bd31f8',
  },
  {
    glb: 'https://d36kdoifvevep6.cloudfront.net/avatars/custom/under-13/glb/B_Boy-04_v01.glb',
    png: 'avatars/custom/under-13/png/Porfile_BB04_v01.png',
    transparentPng: 'avatars/custom/under-13/png/Profile-transparent_B_Boy_04_v01.png',
    id: '90b23f3d4087bb62307c57e9',
  },
  {
    glb: 'https://d36kdoifvevep6.cloudfront.net/avatars/custom/under-13/glb/W_Boy-01_v01.glb',
    png: 'avatars/custom/under-13/png/Porfile_WB01_v01.png',
    transparentPng: 'avatars/custom/under-13/png/Profile-transparent_W_Boy_01_v01.png',
    id: '88932ab63644937abc919886',
  },
  {
    glb: 'https://d36kdoifvevep6.cloudfront.net/avatars/custom/under-13/glb/W_Boy-02_v01.glb',
    png: 'avatars/custom/under-13/png/Porfile_WB02_v01.png',
    transparentPng: 'avatars/custom/under-13/png/Profile-transparent_W_Boy_02_v01.png',
    id: '7347205213fc3adff9732906',
  },
  {
    glb: 'https://d36kdoifvevep6.cloudfront.net/avatars/custom/under-13/glb/W_Boy-03_v01.glb',
    png: 'avatars/custom/under-13/png/Porfile_WB03_v01.png',
    transparentPng: 'avatars/custom/under-13/png/Profile-transparent_W_Boy_03_v01.png',
    id: 'b363fa3a8a5b9ff7e99d536b',
  },
  {
    glb: 'https://d36kdoifvevep6.cloudfront.net/avatars/custom/under-13/glb/W_Boy-04_v01.glb',
    png: 'avatars/custom/under-13/png/Porfile_WB04_v01.png',
    transparentPng: 'avatars/custom/under-13/png/Profile-transparent_W_Boy_04_v01.png',
    id: '070425531a74e6b70153ee8a',
  },
]

export const femGlb = [
  'A_Girl-01_v01.glb',
  'A_Girl-02_v01.glb',
  'A_Girl-03_v01.glb',
  'A_Girl-04_v01.glb',
  'B_Girl-01_v01.glb',
  'B_Girl-02_v01.glb',
  'B_Girl-03_v01.glb',
  'B_Girl-04_v01.glb',
  'W_Girl-01_v01.glb',
  'W_Girl-02_v01.glb',
  'W_Girl-03_v01.glb',
  'W_Girl-04_v01.glb',
]

export const mascGlb = [
  'A_Boy-01_v01.glb',
  'A_Boy-02_v01.glb',
  'A_Boy-03_v01.glb',
  'A_Boy-04_v01.glb',
  'B_Boy-01_v01.glb',
  'B_Boy-02_v01.glb',
  'B_Boy-03_v01.glb',
  'B_Boy-04_v01.glb',
  'W_Boy-01_v01.glb',
  'W_Boy-02_v01.glb',
  'W_Boy-03_v01.glb',
  'W_Boy-04_v01.glb',
]
